import script from "./PurchasePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasePage.vue?vue&type=script&setup=true&lang=js"

import "./PurchasePage.vue?vue&type=style&index=0&id=751ac5de&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751ac5de"]])

export default __exports__